import { extendDecorator, viewModelDecorator } from '@/js/common/Domain/Service/mixins/decorators';
import Vue from 'vue';
import { BonusMilesFilter } from '@features/tourProduct/filterTourProducts';
import template from './template.html';
import './style.scss';

@viewModelDecorator({
    bonusMiles: false,
})
@extendDecorator({
    template,
    events: {
        'click .bonus-miles-checkbox': 'handleClick',
    },
})
export default class BonusMilesView extends Backbone.Epoxy.View {
    initialize(options) {
        this.filterCriteria = options.filterCriteria;
        this.initModelEvents();
        this.render();
    }

    initModelEvents() {
        const initialValue = this.filterCriteria.get('bonusMiles');
        this.viewModel.set('bonusMiles', initialValue);

        this.filterCriteria.on('change:bonusMiles', (model, value) => {
            this.viewModel.set('bonusMiles', value);
        });

        this.viewModel.on('change:bonusMiles', (model, value) => {
            this.filterCriteria.set('bonusMiles', value);
        });
    }

    handleClick() {
        const isDisabled = this.filterCriteria.get('isBonusMilesDisabled');

        if (!isDisabled) {
            const currentValue = this.viewModel.get('bonusMiles');
            this.viewModel.set('bonusMiles', !currentValue);
        }
    }

    render() {
        this.$el.html(template());

        if (this.el?.querySelector('.js-bonus-miles-vue-mount')) {
            const self = this;
            this.vueInstance = new Vue({
                data() {
                    return {
                        bonusMiles: self.viewModel.get('bonusMiles') || false,
                        operators: self.filterCriteria?.get('operators') || [],
                    };
                },
                render(h) {
                    return h(BonusMilesFilter, {
                        props: {
                            modelValue: this.bonusMiles,
                            hideTooltip: true,
                            selectedOperators: this.operators,
                        },
                        on: {
                            'update:modelValue': (value) => {
                                this.bonusMiles = value;
                                self.viewModel.set('bonusMiles', value);
                            },
                        },
                    });
                },
            });

            self.filterCriteria.on('change:operators', (model, value) => {
                this.vueInstance.operators = value || [];
            });

            self.viewModel.on('change:bonusMiles', (model, value) => {
                this.vueInstance.bonusMiles = value;
            });

            this.vueInstance.$mount(this.el.querySelector('.js-bonus-miles-vue-mount'));
        }
    }
}
